<script setup>

</script>

<template>
  <ConfirmDialog
      group="templating"
      dismissable-mask
      draggable
      :pt="{
      root: { class: 'custom-confirmDialog !rounded-md !border-0 !bg-slate-800' },
      header: { class: '!px-4' },
      title: { class: '!text-base !font-normal !py-3' }
    }"
  >
    <template #message="slotProps">
      <div class="flex flex-col items-center w-full gap-4 pt-4">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-circle-alert stroke-red-400"
        >
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" x2="12" y1="8" y2="12"/>
          <line x1="12" x2="12.01" y1="16" y2="16"/>
        </svg>
        <p class="whitespace-pre-line text-center">{{ slotProps.message.message.title }}</p>
        <p class="font-bold">{{ slotProps.message.message.text }}</p>
      </div>
    </template>
  </ConfirmDialog>
</template>
